<template>
    <rkm-area title="Materiais">
        <Form
            v-if="!data.model.confirmado && !data.model.recusado"
            :data="data"
            ref="Form"
        />

        <List
            :data="data"
            ref="List"
        />
    </rkm-area>
</template>

<script>
import Form from './Form'
import List from './List'

export default {
    components: { Form, List },
    methods: {
        resetForm() {

            this.$refs.Form.resetForm()
        },
    },
    props: {
        data: { type: Object, required: true }
    }
}
</script>